export default "__VITE_ASSET__eb1ff32c__"